import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignRequestRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#3F72DA",
			d: "M5.7 4.1h19l.4.2q.7.4 1 1l.2.4v19l-.5 1-1 .6H5.6l-.3-.2q-.6-.3-1-.9l-.2-.4V5.7q.3-.8 1-1.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FEFEFE",
			d: "M20.3 7.1c1-.1 1.7.8 1.5 1.7 0 .4-.7 1.4-1 1.9l-1.4 2.5-.8 1.4-.6.9q-.6.7-1.5 1l-1 .6q-.1-1.4.1-2.9c0-.3.6-1.2.8-1.6l1.3-2.1 1-1.7Q19 7.6 20.3 7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#3F72DA",
			d: "M20.3 7.8q.6 0 .8.6v.2l-.8 1.6-1.5 2.6-.8 1.4c-.4.7-.5.9-1.2 1.3l-.6.3c0-1.4 0-1.4.7-2.6l1.1-1.9 1.2-2 .5-1q.2-.3.6-.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FEFEFE",
			d: "M10.2 9.2H16v.8h-6v10.5h10.5v-6h.8v6.1q-.2.7-.9.7H10q-.7 0-.7-1V10q0-.8 1-.8"
		})
	]
});
export default SvgSignRequestRegularIcon;
